import Vue from "vue";

import {
	NavbarPlugin,
	AlertPlugin,
	ButtonPlugin,
	ButtonGroupPlugin,
	DropdownPlugin,
	TooltipPlugin,
	CollapsePlugin,
	ModalPlugin,
	LayoutPlugin,
	ProgressPlugin,
	SpinnerPlugin,
} from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(NavbarPlugin);
Vue.use(AlertPlugin);
Vue.use(ButtonPlugin);
Vue.use(ButtonGroupPlugin);
Vue.use(DropdownPlugin);
Vue.use(TooltipPlugin);
Vue.use(CollapsePlugin);
Vue.use(ModalPlugin);
Vue.use(LayoutPlugin);
Vue.use(ProgressPlugin);
Vue.use(SpinnerPlugin);
